module.exports = __webpack_public_path__ + "static/media/logoAvatar.c0d08dc1.jpg";